import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import ListApi from "ListApi";
import ListExplorerStore from "ListExplorerStore";
import BaseServiceApi from 'BaseServiceApi';
import SettingsStore from "SettingsStore";
import UserInfoUtil from 'UserInfoUtil';
import DateHelper from "DateHelper";
import DatagraphHelper from "../../../Utils/DatagraphHelper";
import GraphType from "../../../Constants/GraphType";
import DatagraphDataType from "../../../Constants/DatagraphDataType";
import TimeTrackingWindow from "../../../RayCustomControls/TimeTrackingWindow";
import { RiPanelConstants } from "../../../Constants/RiPanelConstants";
import { getDatagraphStates, priceChartReducerselect } from '../../../Reducers/NavDataGraph/TabDataGraph/selectors';
import { getTransactionPanelState } from '../../../Reducers/NavDataGraph/RelatedInfoPanel/selectors';
import transactionsApi from '../../../ServiceApi/Apis/TransactionsApi';
import { getCurrencyReducerState } from "../../../Reducers/CurrencyConversionReducer/selectors";
import DatagraphStore from "../../../Stores/NavModules/NavDataGraph/DataGraphStore";
import { PrintMode } from "../../../print/printmode";


const { ActionTypes } = RiPanelConstants;
const EntitlementType = BaseServiceApi.rayData["EntitlementType"];

function getPeriodicityLastDate(date, periodicity){
    let d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if(periodicity === GraphType.Weekly){
        d = new Date(d)
        let day = d.getDay();
        d.setDate(d.getDate() + (5 - day));
    }
    else if (periodicity === GraphType.Monthly){
        d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
    else if (periodicity === GraphType.Quarterly){
        let year = date.getFullYear();
        let month = date.getMonth();
        let lastMonthOfQuarter = month - (month % 3) + 2; // 2 = Last month of quarter (Mar, Jun, Sep, Dec)
        d =  new Date(year, lastMonthOfQuarter + 1, 0);
        d = new Date(date.getFullYear(), 11, 31)
    }
    else if (periodicity === GraphType.Annual){
        d = new Date(date.getFullYear(), 11, 31)
    }
    return d.getTime();
}

function getAverage(data){

    const total = data.reduce((total, value)=>{
        return total + (value.PRICE * value.QUANTITY)
    }, 0)
    const totalQuantity = data.reduce((total, value)=>{
        return total + value.QUANTITY
    }, 0)
    
    return totalQuantity > 0 ? total/totalQuantity : 0;
}

function getAveragePrice(data, scale){
    return data.map((value)=>{
        return {
            ...value,
            yAxis: scale.ComputeY(getAverage(value.transactions))
        }
    })
}

function* computeTransactions() {
    try {
        TimeTrackingWindow.beginTransactionsRenderTimeTracker();
        const { transactionsData } = yield select(getTransactionPanelState);
        const { scale } = yield select(priceChartReducerselect);
        const { pricePanelData, padding, nodeWidth, startXPoint, periodicity } = yield select(getDatagraphStates);
        const graphData = pricePanelData.HsfData.HSFResults;
        const lastDataNode = graphData.length - 1;
        let xAxis = startXPoint;
        const chartData = { buyPoints: [], sellPoints: [], avgCost: [] };
    
        var transInfo = [];
        if (transactionsData.length > 0) {
            transactionsData.forEach((eachTransaction) => transInfo.push({ "Date": eachTransaction.date, "Action": eachTransaction.orderAction, "Symbol": "", "PRICE": eachTransaction.avgCost, "AVGCOST": eachTransaction.avgCost, "QUANTITY": eachTransaction.quantity }));
        }
        const currTransInfo = transInfo;
        for (let j = padding; j <= lastDataNode; j++) {
            const xPoint = xAxis;
            const buyInfo = {
                xAxis: xPoint,
                transactions: []
            }
            const sellInfo = {
                xAxis: xPoint,
                transactions: []
            }
            currTransInfo.forEach((transaction) => {
                const date = new Date(DateHelper.getUtcFromLong(transaction.Date));
                const dow = date.getDay();
                if (dow === 6) {
                    date.setDate(date.getDate() + 2);
                }
                if (dow === 0) {
                    date.setDate(date.getDate() + 1);
                }
                const price = parseInt(transaction.PRICE);
                const yAxis = scale.ComputeY(price);
    
                if (getPeriodicityLastDate(graphData[j].Date, periodicity) === getPeriodicityLastDate(date, periodicity)) {
                    const avgCost = parseInt(transaction.AVGCOST);
                    let xAvgCost = {
                        Date: date,
                        xAxis: xPoint,
                        yAxis: scale.ComputeY(avgCost),
                        x1Axis: 0,
                        avgCost: avgCost
                    }
                    // create new array and push these values
                    chartData.avgCost.push(xAvgCost);
                }
                if ((transaction.Action === "Buy" || transaction.Action === "Cover Short") &&
                getPeriodicityLastDate(graphData[j].Date, periodicity) === getPeriodicityLastDate(date, periodicity)) {
                    buyInfo.Date = date
                    buyInfo.yAxis = yAxis
                    buyInfo.transactions.push(transaction);
                } else if ((transaction.Action === "Sell" || transaction.Action === "Sell Short") &&
                    getPeriodicityLastDate(graphData[j].Date, periodicity) === getPeriodicityLastDate(date, periodicity)) {
                        sellInfo.Date = date
                        sellInfo.yAxis = yAxis
                        sellInfo.transactions.push(transaction);
                    }
            });
    
            if(buyInfo.Date !== undefined){
                chartData.buyPoints.push(buyInfo);
            }
            if(sellInfo.Date !== undefined){
                chartData.sellPoints.push(sellInfo);
            }
            xAxis -= nodeWidth;
        }
    
        chartData.buyPoints = getAveragePrice(chartData.buyPoints, scale)
        chartData.sellPoints = getAveragePrice(chartData.sellPoints, scale)
        if (chartData.avgCost) {
            chartData.avgCost.sort((a, b) => a.Date.getTime() - b.Date.getTime());
            const totalCount = chartData.avgCost.length;
            for (let jj = 1; jj < totalCount; jj++) {
                const prevTrans = chartData.avgCost[jj - 1];
                const currTrans = chartData.avgCost[jj];
                if (currTrans.avgCost !== prevTrans.avgCost || isNaN(currTrans.avgCost)) {
                    prevTrans.x1Axis = currTrans.xAxis;
                }
            }
        }
    
        yield put({
            type: ActionTypes.SET_COMPUTED_TRANSACTIONS_DATA,
            computedTransactionData: chartData,
        })
        TimeTrackingWindow.endTransactionsLoadEndTimeTracker();

    } catch (error) {
        TimeTrackingWindow.setTimeTrackRenderError(DatagraphDataType.Transactions);
        console.log(`Error occurs in RiPanelTransactions.js, computeTransactions, ${error}`);
    }
}

function* computeUnitCostNodes() {
    try {
        TimeTrackingWindow.beginTransactionsRenderTimeTracker();
        const { unitCostNodes } = yield select(getTransactionPanelState);
        const { scale } = yield select(priceChartReducerselect)
        const { pricePanelData, padding, nodeWidth, startXPoint, periodicity } = yield select(getDatagraphStates);
        const graphData = pricePanelData.HsfData.HSFResults;
        const lastDataNode = graphData.length - 1;
        const chartData = [];
        const dateDict = {};
        if (!graphData || graphData.length <= lastDataNode || graphData.length <= padding) {
            return;
        }
    
        const graphStartPeriod = getPeriodicityLastDate(graphData[lastDataNode].Date, periodicity);
        const graphEndPeriod = getPeriodicityLastDate(graphData[padding].Date, periodicity);
    
        // Group and average unit cost nodes by periodicity bucket
        const grouped = {};
        for (const d of unitCostNodes) {
            const startDate = new Date(DateHelper.getUtcFromLong(d.startDate));
            const bucket = getPeriodicityLastDate(startDate, periodicity);
    
            if (!grouped[bucket]) grouped[bucket] = [];
            grouped[bucket].push(d);
        }
    
        for (const bucket of Object.keys(grouped)) {
            const items = grouped[bucket];
    
            let avgCostSum = 0;
            let startDate = null, endDate = null;
    
            for (const item of items) {
                avgCostSum += item.avgCost;
    
                const s = new Date(DateHelper.getUtcFromLong(item.startDate));
                const e = new Date(DateHelper.getUtcFromLong(item.endDate));
    
                if (!startDate || s < startDate) startDate = s;
                if (!endDate || e > endDate) endDate = e;
            }
    
            const avgCost = parseFloat((avgCostSum / items.length).toFixed(2));
    
            let xAxis = startXPoint;
            startDate = adjustWeekendDate(startDate);
            endDate = adjustWeekendDate(endDate);
    
            const startPeriod = getPeriodicityLastDate(startDate, periodicity);
            const endPeriod = getPeriodicityLastDate(endDate, periodicity);
    
            if (graphStartPeriod > endPeriod || graphEndPeriod < startPeriod) continue;
    
            const dataObject = {
                avgCost,
                startDate,
                endDate,
                yAxis: scale.ComputeY(avgCost),
            };
    
            for (let j = padding; j <= lastDataNode; j++) {
                const xPoint = xAxis;
                const graphDate = graphData[j].Date;
                const graphPeriod = getPeriodicityLastDate(graphDate, periodicity);
    
                if (graphPeriod < startPeriod || graphPeriod > endPeriod) {
                    xAxis -= nodeWidth;
                    continue;
                }
    
                if (graphPeriod === startPeriod) {
                    const ts = startDate.getTime();
                    if (dateDict[ts]) {
                        const nextIdx = Math.min(j + 1, lastDataNode);
                        dateDict[ts].endDate = graphData[nextIdx].Date;
                        dateDict[ts].x2Axis = xPoint;
                    }
                    dataObject.startDate = graphDate;
                    dataObject.x1Axis = xPoint;
                }
    
                if (graphPeriod === endPeriod) {
                    const ts = endDate.getTime();
                    dataObject.endDate = graphDate;
                    dataObject.x2Axis = xPoint + nodeWidth;
                    dateDict[ts] = dataObject;
                }
    
                xAxis -= nodeWidth;
            }
    
            if (!dataObject.x2Axis && endPeriod > graphEndPeriod) {
                dataObject.endDate = graphData[padding].Date;
                dataObject.x2Axis = startXPoint;
            }
    
            if (!dataObject.x1Axis && startPeriod < graphStartPeriod) {
                dataObject.startDate = graphData[lastDataNode].Date;
                dataObject.x1Axis = xAxis + nodeWidth;
            }
    
            if (dataObject.x1Axis && dataObject.x2Axis) {
                chartData.push(dataObject);
            }
        }
    
        yield put({
            type: ActionTypes.SET_COMPUTED_COSTS_DATA,
            computedUnitCostNodes: chartData,
        })
        TimeTrackingWindow.endTransactionsLoadEndTimeTracker();

    } catch (error) {
        TimeTrackingWindow.setTimeTrackRenderError(DatagraphDataType.Transactions);
        console.log(`Error occurs in RiPanelTransactions.js, computeUnitCostNodes, ${error}`);
    }
}

function* computeRoundTripData() {
    try {
        TimeTrackingWindow.beginTransactionsRenderTimeTracker();
        const { roundTripsChartDatas } = yield select(getTransactionPanelState);
        const { pricePanelData, padding, nodeWidth, startXPoint, periodicity } = yield select(getDatagraphStates);
        const { scale } = yield select(priceChartReducerselect)
        const graphData = pricePanelData.HsfData.HSFResults;
        const lastDataNode = graphData.length - 1;
        const chartData = [];
        const dateDict = {};
        if (!graphData || graphData.length <= lastDataNode || graphData.length <= padding) {
            return;
        }

        const graphStartPeriod = getPeriodicityLastDate(graphData[lastDataNode].Date, periodicity);
        const graphEndPeriod = getPeriodicityLastDate(graphData[padding].Date, periodicity);

        // Group and average roundTripData by periodicity bucket
        const grouped = {};
        for (const d of roundTripsChartDatas) {
            const startDate = new Date(DateHelper.getUtcFromLong(d.startDate));
            const bucket = getPeriodicityLastDate(startDate, periodicity);

            if (!grouped[bucket]) grouped[bucket] = [];
            grouped[bucket].push(d);
        }

        for (const bucket of Object.keys(grouped)) {
            const items = grouped[bucket];

            let unitCostSum = 0, sellPriceSum = 0, rest;
            let startDate = null, endDate = null;

            for (const item of items) {
                unitCostSum += item.unitCost;
                sellPriceSum += item.sellPrice;
                rest = { ...item }
                const s = new Date(DateHelper.getUtcFromLong(item.startDate));
                const e = new Date(DateHelper.getUtcFromLong(item.endDate));

                if (!startDate || s < startDate) startDate = s;
                if (!endDate || e > endDate) endDate = e;

            }

            const unitCost = parseFloat((unitCostSum / items.length).toFixed(2));
            const sellPrice = parseFloat((sellPriceSum / items.length).toFixed(2));

            let xAxis = startXPoint;
            startDate = adjustWeekendDate(startDate);
            endDate = adjustWeekendDate(endDate);

            const startPeriod = getPeriodicityLastDate(startDate, periodicity);
            const endPeriod = getPeriodicityLastDate(endDate, periodicity);

            if (graphStartPeriod > endPeriod || graphEndPeriod < startPeriod) continue;
            const dataObject = {
                ...rest,
                unitCost,
                sellPrice,
                startDate,
                endDate,
                y1Axis: scale.ComputeY(unitCost),
                y2Axis: scale.ComputeY(sellPrice),
            };

            for (let j = padding; j <= lastDataNode; j++) {
                const xPoint = xAxis;
                const graphDate = graphData[j].Date;
                const graphPeriod = getPeriodicityLastDate(graphDate, periodicity);

                if (graphPeriod < startPeriod || graphPeriod > endPeriod) {
                    xAxis -= nodeWidth;
                    continue;
                }

                if (graphPeriod === startPeriod) {
                    const ts = startDate.getTime();
                    if (dateDict[ts]) {
                        const nextIdx = Math.min(j + 1, lastDataNode);
                        dateDict[ts].endDate = graphData[nextIdx].Date;
                        dateDict[ts].x2Axis = xPoint;
                    }
                    dataObject.startDate = graphDate;
                    dataObject.x1Axis = xPoint;
                }

                if (graphPeriod === endPeriod) {
                    const ts = endDate.getTime();
                    dataObject.endDate = graphDate;
                    dataObject.x2Axis = graphPeriod === startPeriod ? xPoint + nodeWidth : xPoint;
                    dateDict[ts] = dataObject;
                }

                xAxis -= nodeWidth;
            }

            if (!dataObject.x2Axis && endPeriod > graphEndPeriod) {
                dataObject.endDate = graphData[padding].Date;
                dataObject.x2Axis = startXPoint;
            }

            if (!dataObject.x1Axis && startPeriod < graphStartPeriod) {
                dataObject.startDate = graphData[lastDataNode].Date;
                dataObject.x1Axis = xAxis + nodeWidth;
            }

            if (dataObject.x1Axis && dataObject.x2Axis) {
                chartData.push(dataObject);
            }
        }

        yield put({
            type: ActionTypes.SET_COMPUTED_ROUNDTRIP_DATA,
            computedRoundTripsChartDatas: chartData,
        })
        TimeTrackingWindow.endTransactionsLoadEndTimeTracker();

    }  catch (error) {
        TimeTrackingWindow.setTimeTrackRenderError(DatagraphDataType.Transactions);
        console.log(`Error occurs in RiPanelTransactions.js, computeRoundTripData, ${error}`);
    }
}



/**
 * Adjusts a date that falls on the weekend to the next Monday.
 * Used to ensure data aligns with trading days.
 */
function adjustWeekendDate(date) {
    const day = date.getDay();
    if (day === 6) date.setDate(date.getDate() + 2); // Saturday → Monday
    if (day === 0) date.setDate(date.getDate() + 1); // Sunday → Monday
    return date;
}

function* getPortfolioMinilist({ portfolioId }) {
    try {
        const { userPortfolios, transactionsSettings } = yield select(getTransactionPanelState);
        const selectedPortfolios = transactionsSettings.selectedPortfolios;
        if(![undefined, null].includes(portfolioId) && !selectedPortfolios.includes(portfolioId)) {
            ListExplorerStore.deletePortfolioNode(portfolioId, selectedPortfolios.length === 0);
        }

        const totalTransactions = selectedPortfolios.length;
        const latestSelectedPortfolio = selectedPortfolios[totalTransactions - 1];

        if(latestSelectedPortfolio !== undefined){
            const reponse = yield call(getPortfolioNode, latestSelectedPortfolio, userPortfolios);
            ListExplorerStore.addPortfolioNode(reponse.portfolioNode, reponse.isAddNode)
        }
    }
    catch (error) {
        console.log(`Error occurs in RiPanelTransactions.js, getPortfolioMinilist, ${error}`);
    }
}

function* createPortfolioNode() {
    try {
        const { userPortfolios, transactionsSettings } = yield select(getTransactionPanelState);
        const selectedPortfolios = transactionsSettings.selectedPortfolios;
        for (let portfolioId of selectedPortfolios) {
            const response = yield call(getPortfolioNode, portfolioId, userPortfolios);
            ListExplorerStore.createPortfolioNode(response.portfolioNode, response.isAddNode);
        }
    } catch (error) {
        console.log(`Error occurs in RiPanelTransactions.js, createPortfolioNode, ${error}`);
    }
}

function* getPortfolioNode(portfolioId, userPortfolios){
    try {
        let portfolioName = ''
            userPortfolios.forEach((portfolio) => {
                if(portfolio.portfolioid === parseInt(portfolioId)){
                    portfolioName = portfolio.portfolioname
                }
            });
            let portfolioNode = ListExplorerStore.getPortfolioListNode(parseInt(portfolioId))
            let isAddNode = false
            if(!portfolioNode){
                const listResult = yield call(ListApi.getCreateTreeNode, {
                    dbType: 1,
                    name: `Portfolio holdings ${portfolioName}`,
                    nodeType: 1,
                    parentNodeId: -1,
                    categoryType: 9,
                    sourceListId: '',
                    portfolioID: portfolioId
                });
                portfolioNode = listResult.data;
                portfolioNode.portfolioID = parseInt(portfolioId)
                isAddNode = true;
            }
            return { portfolioNode, isAddNode };
    } catch (error) {
        console.log(`Error occurs in RiPanelTransactions.js, createPortfolioNode, ${error}`);
    }
    return {}
}

function* getUserPortfolios() {
    try {
        const { userPortfolios: loadedUserPortfolio } = yield select(getTransactionPanelState);
        const { endDate } = yield select(getDatagraphStates);
        TimeTrackingWindow.beginTransactionsTimeTracker();
        let userPortfolios = loadedUserPortfolio;

        if(!loadedUserPortfolio || loadedUserPortfolio.length === 0) {
            const userPortfoliosResponse = yield call(transactionsApi.getUserPortfolios, DateHelper.yyyymmdd(endDate));
            userPortfolios = userPortfoliosResponse.results_metric
        }

        if (userPortfolios) {
            userPortfolios.sort((a, b)=> a.portfolioname.localeCompare(b.portfolioname))
            yield put({
                type: ActionTypes.SET_USER_PORTFOLIOS,
                userPortfolios,
            })

            const isTransactionsEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.RAY_ACCOUNT_ANALYZER_VIEW_Entitlement);

            if(isTransactionsEntitled) {
                const consoleSettings = SettingsStore.getConsoleSettings();
                const transactionsSettings = DatagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).TransactionsSettings;
              
                if(userPortfolios && userPortfolios.length > 0){
                    const validPortfolioIds = []
                    userPortfolios.forEach(p => {
                        if((transactionsSettings.selectedPortfolios || []).includes(p.portfolioid)){
                            validPortfolioIds.push(p.portfolioid)
                        }
                    });
                    transactionsSettings.selectedPortfolios = validPortfolioIds
                    SettingsStore.saveSettings();
                }

                yield put({
                    type: ActionTypes.TRANSACTIONS_DATA_READY,
                    transactionsSettings
                })

                if((!loadedUserPortfolio || loadedUserPortfolio.length === 0) && !PrintMode.printing) {
                    yield call(createPortfolioNode)
                    yield fork(getPortfolioMinilist, {})
                }
            }
        }
        TimeTrackingWindow.endTransactionsApiTimeTracker();
    }
    catch (error) {
        console.log(`Error occurs in RiPanelTransactions.js, getUserPortfolios, ${error}`);
        TimeTrackingWindow.setApiTimeTrackError(DatagraphDataType.Transactions);
    }
}

function* getTransactionsData(){
    try {
        TimeTrackingWindow.beginTransactionsTimeTracker();
        const { transactionsSettings } = yield select(getTransactionPanelState);
        const portfolioIds = transactionsSettings.selectedPortfolios.join(", ")
        let transactionsData = []
        const { pricePanelData, periodicity, endDate } = yield select(getDatagraphStates);
        const { isCurrencyConversionChecked } = yield select(getCurrencyReducerState);
        const isShowSelectedCurrency = DatagraphStore.getIsShowSelectedCurrency();
        const isCurrencyChecked = isShowSelectedCurrency && isCurrencyConversionChecked;
        if(!isCurrencyChecked  && [GraphType.Daily, GraphType.Weekly].includes(periodicity)){
            const osid = pricePanelData.SymbolInfo.Osid;
            const currencyCode = pricePanelData.SymbolInfo.DefaultCurrency.Code;
            const priceState = yield select(priceChartReducerselect);
            const transactionsDataResponse = yield call(transactionsApi.getTransactionsData, portfolioIds, osid, currencyCode, DateHelper.yyyymmdd(priceState.startDate), DateHelper.yyyymmdd(endDate));
            if (transactionsDataResponse.nodes) {
                transactionsData = transactionsDataResponse.nodes
            }
        }
        TimeTrackingWindow.endTransactionsApiTimeTracker();
        yield put({
            type: ActionTypes.SET_TRANSACTIONS_DATA,
            transactionsData: transactionsData,
        })

    } catch (error) {
        TimeTrackingWindow.setApiTimeTrackError(DatagraphDataType.Transactions);
        console.log(`Error occurs in RiPanelTransactions.js, getTransactionsData, ${error}`);
    }
}

function* getCostsData(){
    try {
        TimeTrackingWindow.beginTransactionsTimeTracker();
        const { transactionsSettings } = yield select(getTransactionPanelState);
        const portfolioIds = transactionsSettings.selectedPortfolios.join(", ")
        let unitCostNodes = []
        const { pricePanelData, periodicity, endDate } = yield select(getDatagraphStates);
        const { isCurrencyConversionChecked } = yield select(getCurrencyReducerState);
        const isShowSelectedCurrency = DatagraphStore.getIsShowSelectedCurrency();
        const isCurrencyChecked = isShowSelectedCurrency && isCurrencyConversionChecked;
        if(!isCurrencyChecked && [GraphType.Daily, GraphType.Weekly].includes(periodicity)){
            const osid = pricePanelData.SymbolInfo.Osid;
            const currencyCode = pricePanelData.SymbolInfo.DefaultCurrency.Code;
            const priceState = yield select(priceChartReducerselect);
            const unitCostNodesResponse = yield call(transactionsApi.getUnitCostNodes, portfolioIds, osid, currencyCode, DateHelper.yyyymmdd(priceState.startDate), DateHelper.yyyymmdd(endDate));
            if (unitCostNodesResponse.nodes) {
                unitCostNodes = unitCostNodesResponse.nodes
                
            }
        }
        TimeTrackingWindow.endTransactionsApiTimeTracker();
        yield put({
            type: ActionTypes.SET_COSTS_DATA,
            unitCostNodes: unitCostNodes,
        })
    } catch (error) {
        TimeTrackingWindow.setApiTimeTrackError(DatagraphDataType.Transactions);
        console.log(`Error occurs in RiPanelTransactions.js, getCostsData, ${error}`);
    }
}

function* getRoundTripData(){
    try {
        TimeTrackingWindow.beginTransactionsTimeTracker();
        const { transactionsSettings, userPortfolios } = yield select(getTransactionPanelState);
        const portfolioIds = transactionsSettings.selectedPortfolios.join(", ")
        let roundTripsChartData = []
        const portfolioMap = {}
        userPortfolios.forEach((portfolio) => {
            portfolioMap[portfolio.portfolioid] = portfolio.portfolioname
        })
        const { pricePanelData, periodicity, endDate, majorPeriodicity } = yield select(getDatagraphStates);
        const { isCurrencyConversionChecked } = yield select(getCurrencyReducerState);
        const isShowSelectedCurrency = DatagraphStore.getIsShowSelectedCurrency();
        const isCurrencyChecked = isShowSelectedCurrency && isCurrencyConversionChecked;
        let effectiveEndDate = endDate;
        const { startDate } = yield select(priceChartReducerselect);

        if(!isCurrencyChecked && [GraphType.Daily, GraphType.Weekly].includes(periodicity)){
            const osid = pricePanelData.SymbolInfo.Osid;
            const currencyCode = pricePanelData.SymbolInfo.DefaultCurrency.Code;

            const roundTripDataResponse = yield call(transactionsApi.getRoundTripData, portfolioIds, osid, currencyCode, DateHelper.yyyymmdd(startDate), DateHelper.yyyymmdd(effectiveEndDate));
            if (roundTripDataResponse.roundTripsChartDatas) {
                const roundTripData = roundTripDataResponse.roundTripsChartDatas
                roundTripData.forEach((roundTrip) => {
                    roundTrip.portfolioName = portfolioMap[roundTrip.portfolioId]
                    // weeks or days in label based on periodicity
                    roundTrip.xText = majorPeriodicity === GraphType.Weekly
                        ? `${(roundTrip.days / 7).toFixed(1)} week${(roundTrip.days / 7) > 1 ? 's' : ''}`
                        : `${roundTrip.days} day${roundTrip.days > 1 ? 's' : ''}`;
                })
                roundTripsChartData = roundTripData
            }
        }
        TimeTrackingWindow.endTransactionsApiTimeTracker();
        yield put({
            type: ActionTypes.SET_ROUNDTRIP_DATA,
            roundTripsChartDatas: roundTripsChartData,
        })
    } catch (error) {
        TimeTrackingWindow.setApiTimeTrackError(DatagraphDataType.Transactions);
        console.log(`Error occurs in RiPanelTransactions.js, getRoundTripData, ${error}`);
    }
}

function* handleRecalculation() {
    yield all([
        call(computeTransactions),
        call(computeRoundTripData),
        call(computeUnitCostNodes),
    ])
}

export function* watchPriceDataReady() {
    yield takeLatest(ActionTypes.TRANSACTIONS_DATA_READY, getTransactionsData)
    yield takeLatest(ActionTypes.TRANSACTIONS_DATA_READY, getCostsData)
    yield takeLatest(ActionTypes.TRANSACTIONS_DATA_READY, getRoundTripData)
}

export function* watchForRecalculation() {
    yield takeLatest(ActionTypes.RECALCULATE_TRANSACTIONS, handleRecalculation)
    yield takeLatest(ActionTypes.SET_TRANSACTIONS_DATA, computeTransactions)
    yield takeLatest(ActionTypes.SET_ROUNDTRIP_DATA, computeRoundTripData)
    yield takeLatest(ActionTypes.SET_COSTS_DATA, computeUnitCostNodes)
}

export function* watchUserPortfolios() {
    yield takeLatest(ActionTypes.GET_USER_PORTFOLIOS, getUserPortfolios)
}

export function* watchUpdateSelectedPortfolioId(){
    yield takeLatest(ActionTypes.UPDATE_SELECTED_PORTFOLIO_ID, getPortfolioMinilist)
    yield takeLatest(ActionTypes.UPDATE_SELECTED_PORTFOLIO_ID, getTransactionsData)
    yield takeLatest(ActionTypes.UPDATE_SELECTED_PORTFOLIO_ID, getCostsData)
    yield takeLatest(ActionTypes.UPDATE_SELECTED_PORTFOLIO_ID, getRoundTripData)
}
